function playback(backendAxiosInstance) {
  async function getTokenAuthorizer({
    delay = 0,
    mobileNetwork = true,
    isLive,
    contentId
  }) {
    return backendAxiosInstance.post("/entitlement/v3/playback/token/authorizer", {
      delay,
      mobileNetwork,
      isLive,
      contentId
    });
  }
  async function refreshTokenAuthorizer({ delay = 0, mobileNetwork, refreshToken }) {
    return backendAxiosInstance.post("/entitlement/v3/playback/token/refresh", {
      delay,
      mobileNetwork,
      refreshToken
    });
  }
  return {
    getTokenAuthorizer,
    refreshTokenAuthorizer
  };
}

export { playback as default };
//# sourceMappingURL=playback.js.map
